/** student/certificates — API. */
import { http } from '../../_shared/http';
import { portalFetch } from '../../../services/portal-fetch';
import { getBackendApiUrl } from '../../../config/environment';
import type { CampaignCertificateStatus, CertificateValidation } from './types';

export const studentCertificatesApi = {
  status: (campaignId: string) => http.get<CampaignCertificateStatus>(`/certificates/${campaignId}`),

  /** Public validation — works without auth (portalFetch sends no header when logged out). */
  validate: (token: string) =>
    http.get<CertificateValidation>(`/certificates/validate/${encodeURIComponent(token)}`),

  /** Fetch the PDF as a blob (binary) via portalFetch so the JWT is attached. */
  async download(campaignId: string): Promise<{ blob: Blob; filename: string }> {
    const res = await portalFetch(`${getBackendApiUrl()}/certificates/${campaignId}/download`);
    if (!res.ok) throw new Error('Failed to download certificate');
    const blob = await res.blob();
    const cd = res.headers.get('Content-Disposition') ?? '';
    const m = /filename="?([^";]+)"?/.exec(cd);
    return { blob, filename: m?.[1] ?? `certificate-${campaignId}.pdf` };
  },
};
